import { useQuery } from '@tanstack/react-query';
import { UsersApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useUsersQueryControllerGetUserByIdQuery(args, options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useQuery({
        queryKey: ['usersQueryControllerGetUserById', accessControlScope, args],
        queryFn: async () => {
            const api = new UsersApi(accessControlConfig);
            return api.usersQueryControllerGetUserById(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useUsersQueryControllerGetUserByIdQuery.js.map